import React, { PureComponent } from 'react';
import { connect } from 'shalala';

import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class ReporteFacturacionHitsPorPacDownload extends PureComponent {
  state = {
    busy: false,
  };

  handleOnDownloadActionClick = async () => {
    const { filters } = this.props.hits_por_pac;

    this.setState({
      busy: true,
    });

    const params = {
      download: 1,
      from: filters.from,
      to: filters.to,
    };

    try {
      const headers = {};

      const response = await Http.get(`${window.BONJOUR_URL}/app/admin/reportes/hits-por-pac`, {
        params,
        responseType: 'blob',
        headers,
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { busy } = this.state;

    return (
      <LoadingButton
        variant="secondary"
        loading={busy}
        onClick={this.handleOnDownloadActionClick.bind(this, undefined)}
      >
        {busy === true ? 'Descargando' : 'Descargar'}
      </LoadingButton>
    );
  }
}

const mapState = (store) => {
  return {
    hits_por_pac: store.admin.reportes.facturacion.hits_pacs,
  };
};

const mapActions = (actions) => {
  return actions.admin.reportes.facturacion.hits_pacs;
};

export default connect(useStore, mapState, mapActions)(ReporteFacturacionHitsPorPacDownload);
